/**
 * 예약정보 유형
 */
export enum ReservationStatus {
  repairShop = "매장정보",
  repair = "방문정보",
  valet = "발렛정보",
  onSite = "출장정보",
  rush = "출동정보",
}

export type ReservationStatusType = keyof typeof ReservationStatus;
